import React, { useEffect, useState } from 'react';
import Logo from './Logo';
import { Menu, X, Phone } from 'lucide-react';

const links = [
  { label: 'Home', href: '#home' },
  { label: 'About', href: '#about' },
  { label: 'Services', href: '#services' },
  { label: 'What to Expect', href: '#expect' },
  { label: 'Contact', href: '#contact' },
];

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-[#f8f3e6]/95 backdrop-blur-md shadow-sm' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 md:px-10 py-4 flex items-center justify-between">
        <a href="#home" className="shrink-0">
          <Logo size={48} />
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="text-[15px] text-[#2c3f25] hover:text-[#7a8a4c] transition-colors duration-200 relative group"
            >
              {l.label}
              <span className="absolute left-0 -bottom-1 w-0 h-[1.5px] bg-[#3a5232] transition-all duration-300 group-hover:w-full" />
            </a>
          ))}
          <a
            href="tel:8088588389"
            className="btn-primary px-5 py-2.5 rounded-full text-sm font-medium flex items-center gap-2"
          >
            <Phone size={15} />
            Book a session
          </a>
        </nav>

        <button
          className="lg:hidden text-[#2c3f25] p-2"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-[#f8f3e6] border-t border-[#e5dcc0] px-5 py-6">
          <div className="flex flex-col gap-4">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="text-[#2c3f25] text-base py-1"
              >
                {l.label}
              </a>
            ))}
            <a
              href="tel:8088588389"
              className="btn-primary px-5 py-3 rounded-full text-sm font-medium flex items-center justify-center gap-2 mt-2"
            >
              <Phone size={15} />
              Book a session
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
